import * as React from 'react'
import './Logo.css'

export class Logo extends React.PureComponent {
  render(): JSX.Element {
    return <i className="mkc logo" />
  }
}
